<template>
    <div class="print-hide-object">
        <slot>
            <!-- Additional Content Here -->
        </slot>
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>

// 用來當作列印時要隱藏物件的辨識 class
.print-hide-object
{
    // 用來抓取所有要 hide 起來的物件
    visibility: visible !important;
}

// 列印前，有 'print-hide-object' class 的物件都會被加上 'print-hidden' class，
// 因此列印時會隱藏，在列印結束後會移除此 class
.print-hidden
{
    display: none !important;
    visibility: hidden !important;
}

</style>